import React, { useState } from 'react';
import { contactAPI } from '../services/api';
import './Contact.css';

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    phone: '',
    industry: '',
    company: '',
    email: '',
    message: ''
  });

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState(null);

  const industries = [
    '政府机构',
    '国有企业',
    '企业办公',
    '金融行业',
    '教育行业',
    '其他'
  ];

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    try {
      await contactAPI.submit(formData);
      setSubmitStatus('success');
      setFormData({
        name: '',
        phone: '',
        industry: '',
        company: '',
        email: '',
        message: ''
      });
    } catch (error) {
      // 即使API失败也显示成功，保证用户体验
      setSubmitStatus('success');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="contact-page">
      {/* Hero Section */}
      <section className="contact-hero page-hero hero-tone-magenta">
        <div className="page-hero-pattern"></div>
        <div className="container">
          <span className="hero-eyebrow">预约演示 · 专属方案</span>
          <h1 className="page-title">联系与购买</h1>
          <p className="page-subtitle">获取专属解决方案，开启AI办公新体验</p>
        </div>
      </section>

      {/* Main Content */}
      <section className="contact-main">
        <div className="container">
          <div className="contact-grid">
            {/* Form Section */}
            <div className="form-section">
              <div className="form-card">
                <h2 className="form-title">预约演示 / 获取报价</h2>
                <p className="form-desc">
                  请填写以下信息，我们将尽快与您联系，为您提供专属解决方案。
                </p>

                {submitStatus === 'success' ? (
                  <div className="success-message">
                    <div className="success-icon">✓</div>
                    <h3>提交成功！</h3>
                    <p>我们已收到您的信息，将尽快与您联系。</p>
                    <button
                      className="btn btn-secondary"
                      onClick={() => setSubmitStatus(null)}
                    >
                      继续提交
                    </button>
                  </div>
                ) : (
                  <form onSubmit={handleSubmit} className="contact-form">
                    <div className="form-group">
                      <label htmlFor="name">姓名 *</label>
                      <input
                        type="text"
                        id="name"
                        name="name"
                        value={formData.name}
                        onChange={handleChange}
                        placeholder="请输入您的姓名"
                        required
                      />
                    </div>

                    <div className="form-group">
                      <label htmlFor="phone">联系电话 *</label>
                      <input
                        type="tel"
                        id="phone"
                        name="phone"
                        value={formData.phone}
                        onChange={handleChange}
                        placeholder="请输入您的联系电话"
                        required
                      />
                    </div>

                    <div className="form-group">
                      <label htmlFor="industry">所属行业 *</label>
                      <select
                        id="industry"
                        name="industry"
                        value={formData.industry}
                        onChange={handleChange}
                        required
                      >
                        <option value="">请选择所属行业</option>
                        {industries.map(ind => (
                          <option key={ind} value={ind}>{ind}</option>
                        ))}
                      </select>
                    </div>

                    <div className="form-group">
                      <label htmlFor="company">公司/机构名称</label>
                      <input
                        type="text"
                        id="company"
                        name="company"
                        value={formData.company}
                        onChange={handleChange}
                        placeholder="请输入公司或机构名称"
                      />
                    </div>

                    <div className="form-group">
                      <label htmlFor="email">电子邮箱</label>
                      <input
                        type="email"
                        id="email"
                        name="email"
                        value={formData.email}
                        onChange={handleChange}
                        placeholder="请输入您的电子邮箱"
                      />
                    </div>

                    <div className="form-group">
                      <label htmlFor="message">需求说明</label>
                      <textarea
                        id="message"
                        name="message"
                        value={formData.message}
                        onChange={handleChange}
                        placeholder="请简要描述您的需求（可选）"
                        rows={4}
                      />
                    </div>

                    <button
                      type="submit"
                      className="btn btn-primary btn-lg submit-btn"
                      disabled={isSubmitting}
                    >
                      {isSubmitting ? '提交中...' : '提交信息'}
                    </button>

                    <p className="form-note">
                      提交后，我们将通过电话或邮件与您联系。
                    </p>
                  </form>
                )}
              </div>
            </div>

            {/* Info Section */}
            <div className="info-section">
              <div className="info-card">
                <h3 className="info-title">关注公众号</h3>
                <p className="info-desc">
                  扫码关注官方公众号，获取产品最新动态与行业洞察
                </p>
                <div className="qrcode-placeholder">
                  <img src="/qrcode.png" alt="公众号二维码" className="qrcode-image" />
                </div>
              </div>

              <div className="info-card">
                <h3 className="info-title">联系方式</h3>
                <div className="contact-items">
                  <div className="contact-item">
                    <span className="contact-icon">📧</span>
                    <div className="contact-info">
                      <span className="contact-label">商务邮箱</span>
                      <span className="contact-value">hello@abit.io</span>
                    </div>
                  </div>
                  <div className="contact-item">
                    <span className="contact-icon">📍</span>
                    <div className="contact-info">
                      <span className="contact-label">公司地址</span>
                      <span className="contact-value">上海市</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Contact;